import { FormPath } from '@formily/react';
import * as React from 'react';
export const FieldContext = /*#__PURE__*/React.createContext({
  preName: FormPath.parse('')
});
export const useFieldContext = () => React.useContext(FieldContext);
//# sourceMappingURL=es/Other/Field/fieldContext.js.map